import { render, staticRenderFns } from "./comp_RatioBox.vue?vue&type=template&id=536d58b2&scoped=true&"
import script from "./comp_RatioBox.vue?vue&type=script&lang=js&"
export * from "./comp_RatioBox.vue?vue&type=script&lang=js&"
import style0 from "./comp_RatioBox.vue?vue&type=style&index=0&id=536d58b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d58b2",
  null
  
)

export default component.exports